<script>
  import { onMount } from 'svelte'
  import { fade } from 'svelte/transition'
</script>

<style>
  main {
    position: relative;
  }

  a {
    position: absolute;
    bottom: 2rem;
    right: 2rem;
  }

  @media (min-width: 1200px) {
  a {
    right: 0;
    bottom: 0;
  }
}
</style>

<main>
  <div class="container" in:fade|global={{duration: 300}}>
    <slot/>
  </div>
  <a class="feedback" title="Have feedback?" href="mailto:feedback@contract-keeper.com"><img src='help.png' alt='Feedback'></a>
</main>